/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Patient insurance information with two uses: retrieved from Patient details by account number and posted to Update patient insurance.  For updates, several fields are required and/or have restricted values.
 */
export interface PatientInsuranceIntegrationViewModel {
  /**
   * REQUIRED - Insurance Level. (P)rimary, (S)econdary, (T)ertiary are valid values.  The first character only may be used for updates.
   */
  insuranceLevel: string;
  /**
   * Insurance Type code, must be a valid insurance type code
   */
  insuranceType?: string | null;
  /**
   * Policy Number, Alphanumeric policy number, max length 50
   */
  policyNumber?: string | null;
  /**
   * Group Number, Alphanumeric group number, max length 50
   */
  groupNumber?: string | null;
  /**
   * Insurance Plan name, max length 100
   */
  planName?: string | null;
  /**
   * REQUIRED - Relationship of patient to policy holder. Child, Self, Parent, Spouse, Other are valid values
   */
  insuredRelation?: string | null;
  /**
   * Insured last name, max length 50
   */
  insuredLastName?: string | null;
  /**
   * Insured first name, max length 50
   */
  insuredFirstName?: string | null;
  /**
   * Insured middle name, max length 50
   */
  insuredMiddleName?: string | null;
  /**
   * Insured suffix, max length 20
   */
  insuredSuffix?: string | null;
  /**
   * REQUIRED - Insured birth date, required.  Must be after 1/1/1900 and no more than nine months into the future.
   */
  insuredBirthDate?: string | null;
  /**
   * REQUIRED - Insured gender. (M)ale, (F)emale, (O)ther are valid values.
   */
  insuredGender?: string | null;
  /**
   * Required: This value is true, or InsuredAddress1, InsuredCity, InsuredState, InsuredZip, and InsuredCountryCode are populated.
   */
  useGuarantorContactInfo?: boolean;
  /**
   * Insured address line 1, max length 100
   */
  insuredAddress1?: string | null;
  /**
   * Insured address line 2, max length 100
   */
  insuredAddress2?: string | null;
  /**
   * Insured city, max length 50
   */
  insuredCity?: string | null;
  /**
   * Insured state code, must be a valid US state
   */
  insuredStateCode?: string | null;
  /**
   * Insured zip code, max length 20
   */
  insuredZip?: string | null;
  /**
   * Insured country code, max length 20
   */
  insuredCountryCode?: string | null;
  /**
   * Insured phone number, max length 30
   */
  insuredPhone?: string | null;
  /**
   * Optional, policy effective date
   */
  policyEffectiveFrom?: string | null;
  /**
   * Optional, policy termination date
   */
  policyEffectiveTo?: string | null;
  /**
   * True if practice accepts carrier assignment
   */
  acceptAssignment?: boolean | null;
  /**
   * Unique carrier code, max length 50, required: either CarrierCode OR Name+Address1+City+State+ZIP
   */
  carrierCode?: string | null;
  /**
   * Insurance carrier name, max length 100
   */
  carrierName?: string | null;
  /**
   * Insurance carrier address line 1, max length 100
   */
  carrierAddress1?: string | null;
  /**
   * Insurance carrier address line 2, max length 100
   */
  carrierAddress2?: string | null;
  /**
   * Insurance carrier city, max length 50
   */
  carrierCity?: string | null;
  /**
   * Insurance carrier state code, must be a valid US state code
   */
  carrierStateCode?: string | null;
  carrierZip?: string | null;
  /**
   * Insurance carrier country code, max length 20
   */
  carrierCountryCode?: string | null;
  /**
   * insurance carrier phone number, max length 20
   */
  carrierPhoneNumber?: string | null;
  /**
   * Insurance carrier type for example: PPO, Commercial, Medicaid, etc., max length 100
   */
  carrierType?: string | null;
  /**
   * Insurance carrier Payer Id
   */
  payerId?: string | null;
  /**
   * External Id, max length 50
   */
  externalId?: string | null;
  /**
   * Peregrine\'s internal Id for this insurance, readonly
   */
  id?: string;
}
